export default [
	// --- ログインが必要な組織関連 ---
	{
		path: '/app/organization',
		component: () => import('../../../layouts/MainLayout.vue'), // 通常のレイアウト
		children: [
			{
				path: 'register',
				name: 'organizationRegister',
				component: () => import(/* webpackChunkName: "organization" */ '../../../components/organization/OrganizationRegisterView'),
				meta: { title:'YubiOn SecureFileTransfer | Organization Registration'}
			},
			{
				path: 'invitation/confirmation',
				name: 'organizationInvitationConfirmation',
				component: () => import('../../../components/organization/OrganizationInviteView'),
				meta: { title:'YubiOn SecureFileTransfer | Invitation Confirmation'}
			},
			{
				path: 'invitations',
				name: 'organizationInvitationList',
				component: () => import('../../../components/organization/OrganizationInvitationListView'),
				meta: { title:'YubiOn SecureFileTransfer | Invitation List'}
			}
		]
	},
	{
		path: '/app/organization/management',
		component: () => import('../../../layouts/OrganizationMainLayout.vue'), // 組織管理専用
		children: [
			{
				path: '',
				name: 'organizationDashboard',
				component: () => import('../../../components/organization/OrganizationManagementView.vue'),
				meta: { title:'YubiOn SecureFileTransfer | Organization Dashboard'}
			},
			{
				path: 'members',
				name: 'organizationMembers',
				component: () => import('../../../components/organization/OrganizationMembersView.vue'),
				meta: { title:'YubiOn SecureFileTransfer | Organization MemberList'}
			},
			/**
			 * 将来用
			{
				path: 'management/policy',
				name: 'organizationPolicy',
				component: () => import('../../../components/organization/OrganizationPolicyView.vue'),
			}
			*/
		]
	},
	// --- 未ログインでもアクセス可能な組織関連（招待など） ---
	{
		path: '/app/organization',
		component: () => import('../../../layouts/UnauthLayout.vue'), // 通常のレイアウト
		children: [
			{
				path: 'join/:key',
				name: 'organizationInvite',
				component: () => import('../../../components/organization/OrganizationInviteView'),
				meta: { title:'YubiOn SecureFileTransfer | Join Organization'}
			},
		]
	}
]